module.exports = __webpack_public_path__ + "static/media/credit-card.ed421989.png";